import {
  Component,
  OnDestroy,
  OnInit,
  HostListener,
  // ViewEncapsulation
} from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { MainMenuModel } from '../../../../shared/models/navigation.model';

import { MainMenuEnum } from '../../../../shared/enums/navigation.enum';
import { getMainMenu } from '../../../../shared/utils/navigation.utils';
import { TokenStorageService } from '../../../../auth/shared/services/token-storage.service';
import {AlertService} from '../../../../shared/services/alert.service';
import { JiraWidgetService } from '../../../../shared/services/jira-widget.service';

@Component({
  selector: 'app-common-container',
  templateUrl: './common-container.component.html',
  styleUrls: ['./common-container.component.scss'],
  // encapsulation: ViewEncapsulation.None
})
export class CommonContainerComponent implements OnInit, OnDestroy {

  userProfile: any;

  public showAlert = 0;
  public showUserDropdown$: Observable<boolean>;
  public showSideMenu = false;
  public employeeFullName: string;
  public notifications: any[] = [];
  public companyList$: Observable<any[]>;
  public employeeList$: Observable<any[]>;

  public title: string;
  public subTitle: string;
  public menuId: MainMenuEnum;
  public showSidebar = true;
  public mainMenu: MainMenuModel[];
  public sidebar = true;
  public showAppLoader: boolean;
  public paymentStatus: string;

  public avatarChange$: Subscription;

  constructor(
    private tokenStorageService: TokenStorageService,
    private alertService: AlertService,
    private jiraWidgetService: JiraWidgetService
  ) {
  }

  public ngOnInit(): void {
    this.userProfile = this.tokenStorageService.getUser();
    this.mainMenu = getMainMenu(this.userProfile);
    this.avatarChange$ = this.tokenStorageService.avatarChange.subscribe(res => {
      this.userProfile = this.tokenStorageService.getUser();
    });
    this.alertService.showAlert$.subscribe(data => {
      this.showAlert = data;
    });
    this.jiraWidgetService.load();
  }

  ngOnDestroy(): void {
    this.avatarChange$.unsubscribe();
  }

  public updateMainMenu(): void {
    /**
     * @route /
     * @dispatch [Layout] Init main menu
     */
    // this.store.dispatch(LayoutActions.initMainMenuAction({ id: this.menuId }));

    // const sessionCompanyId = +localStorage.getItem(SessionStorageEnum.SelectedCompany);

    // if (this.showCompanySearch && !sessionCompanyId !== !this.selectedCompanyId) {
    //   this.onCompanySelect(sessionCompanyId);
    // }

    // if (!this.showCompanySearch && this.selectedCompanyId) {
    //   this.onCompanySelect(null);
    // }

    // const sessionEmployeeId = +localStorage.getItem(SessionStorageEnum.SelectedEmployee);

    // if (this.showEmployeeSearch && !sessionEmployeeId !== !this.selectedEmployeeId) {
    //   this.onEmployeeSelect(sessionEmployeeId);
    // }

    // if (!this.showEmployeeSearch && this.selectedEmployeeId) {
    //   this.onEmployeeSelect(null);
    // }
  }

  public openSubmenu(menuId: MainMenuEnum): void {
    /**
     * @route /
     * @dispatch [Layout] Open submenu
     */
    // this.store.dispatch(LayoutActions.openSubmenuAction({ id: menuId }));
  }

  public toggleUserDropdown(): void {
    /**
     * @route /
     * @dispatch [Layout] Toggle user dropdown
     */
    // this.store.dispatch(LayoutActions.toggleUserDropdownAction());
  }

  public logout(): void {
    this.tokenStorageService.logout();
  }

  public toggleSideMenu(): void {
    this.showSideMenu = !this.showSideMenu;
    // this.store.dispatch(LayoutActions.toggleSideMenuAction());
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: any): void {
    if (this.showSideMenu && !event.target.closest('.common-right-sidebar') && !event.target.closest('app-common-header')) {
      this.showSideMenu = false;
    }
  }

  public toggleSidebar(): void {
    /**
     * @route /
     * @dispatch [Layout] Toggle sidebar
     */
    // this.store.dispatch(LayoutActions.toggleSidebarAction());
  }

  public closeAlert(): void {
    this.showAlert = 0;
  }
}
